import moment from 'moment';
import { DATE_FORMAT } from '../../../constants';

export const checkValidations = (fromDate, toDate) => {
    if (fromDate === null && toDate !== null) {
        return "Delivery 'From' date cannot be empty";
    }
    if (fromDate !== null && toDate === null) {
        return "Delivery 'To' date cannot be empty";
    }
    else if (fromDate !== null && toDate !== null && moment(fromDate).isAfter(toDate)) {
        return "Delivery 'To' date must be after 'From' date";
    }
    else if(moment(toDate).isAfter(new Date())) {
        return "Delivery 'To' date cannot be more than today's date"
    }
    else {
        return '';
    }

}

const isWithin5Month = (fromDate) => {
    let REFERENCE = moment().subtract(5, 'months').startOf('day');
    return fromDate.isAfter(REFERENCE)
}

export const returnCheckedFormItems = (data) => {
    return Object.entries(data).filter(value => value[1] === true).map(key => key[0])
}

export const returnTempZoneList = (tempFilterFormValues, regionListItems) => {
    let tempZoneList = [];
    for (let i = 0; i < tempFilterFormValues.length; i++) {
        if (regionListItems.find(x => x.name === tempFilterFormValues[i])) {
            tempZoneList.push(regionListItems.find(x => x.name === tempFilterFormValues[i]).id);
        }
    }
    return tempZoneList;
}

export const returnTempReportType = (tempFilterFormValues, repoortTypeListItems) => {
    let tempReportType = [];
    for (let i = 0; i < tempFilterFormValues.length; i++) {
        if (repoortTypeListItems.find(x => x.productName === tempFilterFormValues[i])) {
            tempReportType.push(repoortTypeListItems.find(x => x.productName === tempFilterFormValues[i]).id);
        }
    }
    return tempReportType;
}

export const returnTempCountryData = (selectedCountry) => {
    let tempCountry = [];
    if(selectedCountry != null) {
    if (Object.keys(selectedCountry).length > 0) {
        tempCountry.push(selectedCountry.value)
    }
}
    return tempCountry
}

export const returnTempStateData = (selectedState) => {
    let tempState = [];
    if (selectedState.length > 0) {
        selectedState.forEach(state => {
            tempState.push(state.label)
        })
    }
    return tempState
}

export const countryCheck = (selectedCountry) => {
    if (!selectedCountry) {
        return false;
    }
    if (selectedCountry.id === 'IN') {
        return true
    } else {
        return false
    }
}

export const setMultiSelectData = (data) => {
    let tempData = [];
    data.forEach((item) => {
        tempData.push({ label: item.value, value: item.id })
    })
    return tempData;
}